/** The first day of activity history: older audit records are incomplete, so they stay hidden. */
export const ACTIVITY_HISTORY_MIN_DAY = "2026-01-01";
